/**
 * Affiliate Management Page (星推官)
 * Four tabs: application review, affiliate management, payout review, and program config.
 */

import { Megaphone } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/Tabs';
import { useI18n } from '@/i18n';
import { AffiliateApplicationsTab } from '@/features/affiliate/components/AffiliateApplicationsTab';
import { AffiliatesTab } from '@/features/affiliate/components/AffiliatesTab';
import { AffiliatePayoutsTab } from '@/features/affiliate/components/AffiliatePayoutsTab';
import { AffiliateConfigTab } from '@/features/affiliate/components/AffiliateConfigTab';

export function AffiliateManagementPage() {
  const { t } = useI18n();

  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <Megaphone className="w-8 h-8 text-primary" />
        <div>
          <h1 className="text-2xl font-bold text-foreground">{t('affiliatePage.pageTitle')}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t('affiliatePage.pageDescription')}</p>
        </div>
      </div>

      <Tabs defaultValue="applications">
        <TabsList className="mb-6">
          <TabsTrigger value="applications">{t('affiliatePage.tabApplications')}</TabsTrigger>
          <TabsTrigger value="affiliates">{t('affiliatePage.tabAffiliates')}</TabsTrigger>
          <TabsTrigger value="payouts">{t('affiliatePage.tabPayouts')}</TabsTrigger>
          <TabsTrigger value="config">{t('affiliatePage.tabConfig')}</TabsTrigger>
        </TabsList>

        <TabsContent value="applications">
          <AffiliateApplicationsTab />
        </TabsContent>
        <TabsContent value="affiliates">
          <AffiliatesTab />
        </TabsContent>
        <TabsContent value="payouts">
          <AffiliatePayoutsTab />
        </TabsContent>
        <TabsContent value="config">
          <AffiliateConfigTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
